import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { styled, useTheme } from "@mui/material/styles";

import axios from "axios";
import "./Siteauditstyle.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import fav_icon from "./../Asset/New_Assert/ESO_ICON.png";
import LiquidFillGauge from "react-liquid-gauge";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { Link, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import Loader from "../CommonLoader";
import { Commonfun } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { timezoneval } from './../Commonfun';
import { timezonechange } from "./../Commonfun";
import { Utils } from "../../../Utils/Utils";
import plagiarismscanreport_total_wordson_pagesvg from "../Asset/esocardicon/plagiarism/plagiarismscanreport_total_wordson_page.svg"
import plagiarism_totalmatching_urlsvg from "../Asset/esocardicon/plagiarism/plagiarism_scan_report _total_matching_word.svg"
import plagiarismreport_percentage_matchingsvg from "../Asset/esocardicon/plagiarism/plagiarismreport_percentage_matching.svg"
import PdfandCsv from "../PdfandCsv";
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Commoncard from "../Commoncard";
import UserActivityTracker from "../../../hooks/userActivityTracker";



export default function Pagehealthdetail() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [sitecardData, setSitecardData] = useState([]);
  const [internalcardData, setInternalcardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalpercecntwords, setTotalpercentwords] = useState("");
  const [queryurl, setQueryurl] = useState("");
  const [value, setValue] = useState("1");
  const [rescardData, setRescardData] = useState([]);
  const [jobDate, setjobDate] = useState("");
  const esodata = useSelector((state) => state);
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [pagehealthPlan, setpagehealthPlan] = useState({ status: true, error: "" });
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const ApiToken = esodata.apiauthkey.value
  let querystring = useParams();
  let plag_id = querystring.id;
  let onpageid = querystring.onpageid;
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));


  const MyCustomNoRowsOverlay = () => (
    <StyledGridOverlay>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Box sx={{ mt: 1 }}>No Data</Box>
    </StyledGridOverlay>


  );
  let detailurl = `${process.env.REACT_APP_DOMAIN}plagiarism-scan-detail/`;

  useEffect(() => {
    checkUserPlan();
  }, []);

  const checkUserPlan = async () => {
    const pagehealthP = await Utils("page_health", ApiToken);
    if (pagehealthP.status) {
      callUserdataApi();
    }
    setpagehealthPlan(pagehealthP);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const callUserdataApi = async () => {
    setLoading(true);
    setTableLoading(true);
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}technical/pagehealth/detail/${plag_id}/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${esodata.sectiondomaindata.value}&job_id=${onpageid}`,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK") {
        navigate('/errorpages')
      }
    });
    const dataval = datavalue?.data;
    setQueryurl(dataval?.url);
    setjobDate(moment(dataval?.job_date).format("MMM DD,YYYY h:mm"));
    setCardData(dataval);

    const newData1 = dataval?.page_metrics_list.map((obj, index) => {
      return { ...obj, sid: index + 1 };
    });
    setSitecardData(newData1);
    const newData2 = dataval?.internal_link_list.map((obj, index) => {
      return { ...obj, sid: index + 1 };
    });
    setInternalcardData(newData2);
    if (dataval?.seo_metrics_list.length > 0) {
      const newData = dataval?.seo_metrics_list.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setRescardData(newData);
      SetAutoheightval(false)
    }
    else {
      setRescardData("")
      SetAutoheightval(true)
    }
    setTableLoading(false);
    setLoading(false);
  };

  const rows = rescardData ?? [];
  const rows1 = sitecardData ?? [];
  const rows2 = internalcardData ?? [];

  const SeoMetricsArray = [

    {
      key: 'no_index_robot',
      value: 'The web pages must be accessible to Search engines for better SEO results. This metric will check if the web page is accessible to search engines'
    },
    {
      key: 'missing_canonical',
      value: 'Canonical URLs inform search engines that a specific URL represents the source of the content on a web page. This metric will check for a canonical URL or tag on the web page.or tag on the web page'
    },
    {
      key: 'missing_titles',
      value: 'The title tag specifies the web page title. This metric will show the total number of webpages that have a missing title.'
    },
    {
      key: 'duplicate_h1_tags',
      value: 'H1 tags are used to define important HTML headings. This metric will show the total number of webpages that have the same H1 tags.'
    },
    {
      key: 'missing_h1_tags',
      value: 'H1 tags are used to define important HTML headings. This metric will show the total number of webpages that have missing H1 tags.'
    },
    {
      key: 'hreflang',
      value: "Hreflang is an HTML attribute used to specify a web page's language and geographic target. This metric displays the total count of webpages using the hreflang attribute."
    },
    {
      key: 'pagination_prev_or_next',
      value: "This metrics displays the count of Page URLs which have next and previous URLs"
    },
    {
      key: 'duplicate_titles',
      value: "The title tag specifies the web page title. This metric will show the total number of web pages with the same title."
    },
    {
      key: 'duplicate_descriptions',
      value: "The description tag specifies the description of the web page. This metric populates the total number of webpages that have the same description."
    },
    {
      key: 'missing_descriptions',
      value: "The description tag specifies the description of the web page. This metric populates the total number of web pages that have a missing description."
    },
    {
      key: 'missing_alt_tags',
      value: "The ALT tag describes the presence or function of an image on a web page. This metric will show the total count of images on a web page that have missing ALT tags."
    },
    {
      key: 'h1_tags_available',
      value: "H1 tags are used to define important HTML headings. This metric will show the total number of webpages that have an H1 tag. will show the total number of webpages that have the same H1 tags. that have an H1 tag"
    },
    {
      key: 'images_available',
      value: "Images Available	This metric provides the total number of images available in the domain."
    },
    {
      key: 'server_error_5xx_link',
      value: "The 5xx status code means that the server failed to complete a request. This metric displays the count of web pages that return a 5xx status code."
    },
    {
      key: 'broken_links_4xx_link',
      value: "The 4xx status code means that the request for a web page or other resource contains bad syntax. This metric displays the count of web pages that return a 4xx status code."
    }


  ];

  function findObjectByKeyValue(array, key, value) {
    return array.find(obj => obj[key] === value);
  }


  const columns = [
    {
      field: "seo_metrics",
      headerName: "SEO Metrics",
      description: 'On-page SEO elements present in the website.',
      minWidth: 250,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        var ToolTipTitle = '';

        const result = findObjectByKeyValue(SeoMetricsArray, 'key', cardData.row.seo_metrics);

        if (result !== undefined) {
          ToolTipTitle = result.value
        }



        if (ToolTipTitle != '') {
          return (
            <Tooltip title={ToolTipTitle}>
              <p>{cardData.row.seo_metrics}</p>
            </Tooltip>
          );
        }

        else {

          return (
            <p>{cardData.row.seo_metrics}</p>
          );

        }

      },
    },
    {
      field: "priority",
      headerName: "Priority",
      description: 'SEO and site parameters can be prioritized and categorized according to your organization’s marketing strategies in the site audit settings.',
      minWidth: 350,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {
        return (
          <p className="button_score_org">{`${cardData?.row?.priority}`}</p>
        );
      },
    },
    {
      field: "occurences",
      headerName: "Occurrences",
      description: 'The total number of specific metrics present in the website',
      minWidth: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
  ];

  const column1 = [
    {
      field: "site_metrics",
      headerName: "Page Metrics",
      description: 'Website Metrics present in the website',
      minWidth: 500,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        var ToolTipTitle = '';

        const result = findObjectByKeyValue(SeoMetricsArray, 'key', cardData.row.site_metrics);

        if (result !== undefined) {
          ToolTipTitle = result.value
        }



        if (ToolTipTitle != '') {
          return (
            <Tooltip title={ToolTipTitle}>
              <p>{cardData.row.site_metrics}</p>
            </Tooltip>
          );
        }

        else {

          return (
            <p>{cardData.row.site_metrics}</p>
          );

        }

      },
    },

    {
      field: "occurences",
      headerName: "Occurrences",
      description: 'The total number of specific metrics present in the website',
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
  ];
  const column2 = [
    {
      field: "internal_links",
      headerName: "Internal Links",
      description: 'It displays Server Error Links (5xx) and Broken Links (4xx) in the website',
      minWidth: 500,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        var ToolTipTitle = '';

        const result = findObjectByKeyValue(SeoMetricsArray, 'key', cardData.row.internal_links);

        if (result !== undefined) {
          ToolTipTitle = result.value
        }



        if (ToolTipTitle != '') {
          return (
            <Tooltip title={ToolTipTitle}>
              <p>{cardData.row.internal_links}</p>
            </Tooltip>
          );
        }

        else {

          return (
            <p>{cardData.row.internal_links}</p>
          );

        }

      },
    },
    {
      field: "priority",
      headerName: "Priority",
      description: 'SEO and site parameters can be prioritized and categorized according to your organization’s marketing strategies in the site audit settings.',
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {
        return (
          <p className="button_score_org">{`${cardData?.row?.priority}`}</p>
        );
      },
    },
    {
      field: "occurences",
      headerName: "Occurrences",
      description: 'The total number of specific metrics present in the website',
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
  ];
  var state = {
    value: totalpercecntwords,
  };
  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const textfillColor = "rgb(255,255,255)";
  const fillColor = "#ff601f";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/pagehealth/detail/${plag_id}/?user_domain_id=${esodata.domaindata.value.header_selected}&is_format=pdf&timezone=${timezoneval()}&job_id=${onpageid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("pageHealthdetail", "pdf", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);
  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/pagehealth/detail/${plag_id}/?user_domain_id=${esodata.domaindata.value.header_selected}&is_format=csv&timezone=${timezoneval()}&job_id=${onpageid}`, {

        method: 'GET',
        headers: {
          'Content-Type': 'application/csv',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("pageHealthdetail", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();



        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const cardChart = () => {
    return (
      <LiquidFillGauge
        style={{ margin: "0 auto" }}
        width={50}
        height={50}
        value={cardData?.high_impact_percentage}
        percent="%"
        textSize={1}
        textOffsetX={0}
        textOffsetY={0}
        riseAnimation
        waveAnimation
        waveFrequency={2}
        waveAmplitude={1}
        gradient
        gradientStops={gradientStops}
        circleStyle={{
          fill: "#0b2033",
        }}
        waveStyle={{
          fill: "rgb(255,174,31)",
        }}
        textStyle={{
          fill: color("#0b2033").toString(),
          fontFamily: "Arial",
        }}
        waveTextStyle={{
          fill: color("#0b2033").toString(),
          fontFamily: "Arial",
        }}
      />
    )
  }

  const cardChart1 = () => {
    return (
      <LiquidFillGauge
        style={{ margin: "0 auto" }}
        width={50}
        height={50}
        value={cardData?.medium_impact_percentage}
        percent="%"
        textSize={1}
        textOffsetX={0}
        textOffsetY={0}
        riseAnimation
        waveAnimation
        waveFrequency={2}
        waveAmplitude={1}
        gradient
        gradientStops={gradientStops}
        circleStyle={{
          fill: "#0b2033",
        }}
        waveStyle={{
          fill: "rgb(255,174,31)",
        }}
        textStyle={{
          fill: color("#0b2033").toString(),
          fontFamily: "Arial",
        }}
        waveTextStyle={{
          fill: color("#0b2033").toString(),
          fontFamily: "Arial",
        }}
      />
    )
  }

  const cardChart2 = () => {
    return (
      <LiquidFillGauge
        style={{ margin: "0 auto" }}
        width={50}
        height={50}
        value={cardData?.low_impact_percentage}
        percent="%"
        textSize={1}
        textOffsetX={0}
        textOffsetY={0}
        riseAnimation
        waveAnimation
        waveFrequency={2}
        waveAmplitude={1}
        gradient
        gradientStops={gradientStops}
        circleStyle={{
          fill: "#0b2033",
        }}
        waveStyle={{
          fill: "rgb(255,174,31)",
        }}
        textStyle={{
          fill: color("#0b2033").toString(),
          fontFamily: "Arial",
        }}
        waveTextStyle={{
          fill: color("#0b2033").toString(),
          fontFamily: "Arial",
        }}
      />
    )
  }

  const cardDatas = [
    {
      value: cardChart(),
      title: `High Impact Issue Occurrences -- ${cardData?.high_impact_issue}`,
      altText: "High Impact Issue Occurrences",
      iconSrc: plagiarismscanreport_total_wordson_pagesvg,
      iconColor: 1,
      bgColor: 1
    },
    {
      value: cardChart1(),
      title: `Medium Impact Issue Occurrences -- ${cardData?.medium_impact_issue}`,
      altText: "Medium Impact Issue Occurrences",
      iconSrc: plagiarism_totalmatching_urlsvg,
      iconColor: 2,
      bgColor: 2
    },
    {
      value: cardChart2(),
      title: `Low Impact Issue Occurrences -- ${cardData?.low_impact_issue}`,
      altText: "Low Impact Issue Occurrences",
      iconSrc: plagiarismreport_percentage_matchingsvg,
      iconColor: 3,
      bgColor: 3
    },


  ];


  return (
    <div className={`over_all_container page-health ${isMenuExpanded ? "blur overflow-hidden" : ""}`} >
      <div className="">
        {loading === true ? <Loader /> : null}
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Helmet>
          <meta charSet="utf-8" />
          <title>Page Health Detail </title>
        </Helmet>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Page Health Detailed Report
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Technical' },
                        { title: 'Page Health', activeColor: true, link: '/page-health/3/' },
                        { title: 'View Report', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-time">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={6}>
                <div className="time_zone">
                  <span><a target="_blank" href={queryurl}>
                    <span style={{ display: 'inline-block' }} className="spanlink">
                      {queryurl}
                    </span>
                  </a></span><br></br>
                  <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                  <span className="timezone-val">{timezoneval()}</span>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="drop_down_button" >
                  <Link to={`/page-health-ignore-metrics/${plag_id}/${onpageid}`}>
                    <button
                      className="btn_dashboard"
                      style={{ border: "2px solid #fff" }}
                    >
                      Ignored Metrics
                    </button>
                  </Link>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>




        {/* <Container maxWidth={false} className="dashboard-card-container">
          <Box className="dashboard-box-card">
            <Grid container className="dashboard-card-grid">

              <Grid item xs={12} md={12}>

                <div className="cnt_hdr_content">
                  <div className="box_wrap page_health">
                    <div>
                      <p></p>
                    </div>
                    <div className="common-card-container" style={{ justifyContent: "center" }}>
                      <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }}>
                        <div className={`common-card-icon-container`}>
                          <div className={`common-card-icons`}>
                            <img src={plagiarismscanreport_total_wordson_pagesvg} className={`common-card-icon-img`} alt=" Total Words on Pages" />
                          </div>
                        </div>
                        <div className={`common-card-subtitle cardcontentactivecontainer`}>
                          <span className="common-card-title">  High Impact Issue Occurrences -- {cardData?.high_impact_issue} </span>
                          <span className="common-card-value">
                            <LiquidFillGauge
                              style={{ margin: "0 auto" }}
                              width={50}
                              height={50}
                              value={cardData?.high_impact_percentage}
                              percent="%"
                              textSize={1}
                              textOffsetX={0}
                              textOffsetY={0}
                              riseAnimation
                              waveAnimation
                              waveFrequency={2}
                              waveAmplitude={1}
                              gradient
                              gradientStops={gradientStops}
                              circleStyle={{
                                fill: "#0b2033",
                              }}
                              waveStyle={{
                                fill: "rgb(255,174,31)",
                              }}
                              textStyle={{
                                fill: color("#0b2033").toString(),
                                fontFamily: "Arial",
                              }}
                              waveTextStyle={{
                                fill: color("#0b2033").toString(),
                                fontFamily: "Arial",
                              }}
                            />
                          </span>
                        </div>
                      </div>
                      <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }}>
                        <div className={`common-card-icon-container`}>
                          <div className={`common-card-icons`}>
                            <img src={plagiarism_totalmatching_urlsvg} className={`common-card-icon-img`} alt="  Total Words" />
                          </div>
                        </div>
                        <div className={`common-card-subtitle cardcontentactivecontainer`}>
                          <span className="common-card-title">     Medium Impact Issue Occurrences -- {cardData?.medium_impact_issue}</span>
                          <span className="common-card-value">

                            <LiquidFillGauge
                              style={{ margin: "0 auto" }}
                              width={50}
                              height={50}
                              value={cardData?.medium_impact_percentage}
                              percent="%"
                              textSize={1}
                              textOffsetX={0}
                              textOffsetY={0}
                              riseAnimation
                              waveAnimation
                              waveFrequency={2}
                              waveAmplitude={1}
                              gradient
                              gradientStops={gradientStops}
                              circleStyle={{
                                fill: "#0b2033",
                              }}
                              waveStyle={{
                                fill: "rgb(255,174,31)",
                              }}
                              textStyle={{
                                fill: color("#0b2033").toString(),
                                fontFamily: "Arial",
                              }}
                              waveTextStyle={{
                                fill: color("#0b2033").toString(),
                                fontFamily: "Arial",
                              }}
                            />
                          </span>
                        </div>
                      </div>

                      <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }}>
                        <div className={`common-card-icon-container`}>
                          <div className={`common-card-icons`}>
                            <img src={plagiarismreport_percentage_matchingsvg} className={`common-card-icon-img`} alt="  Total Words" />
                          </div>
                        </div>
                        <div className={`common-card-subtitle cardcontentactivecontainer`}>
                          <span className="common-card-title"> Low Impact Issue Occurrences -- {cardData?.low_impact_issue} </span>
                          <span className="common-card-value">

                            <LiquidFillGauge
                              style={{ margin: "0 auto" }}
                              width={50}
                              height={50}
                              value={cardData?.low_impact_percentage}
                              percent="%"
                              textSize={1}
                              textOffsetX={0}
                              textOffsetY={0}
                              riseAnimation
                              waveAnimation
                              waveFrequency={2}
                              waveAmplitude={1}
                              gradient
                              gradientStops={gradientStops}
                              circleStyle={{
                                fill: "#0b2033",
                              }}
                              waveStyle={{
                                fill: "rgb(255,174,31)",
                              }}
                              textStyle={{
                                fill: color("#0b2033").toString(),
                                fontFamily: "Arial",
                              }}
                              waveTextStyle={{
                                fill: color("#0b2033").toString(),
                                fontFamily: "Arial",
                              }}
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container> */}
        <Container maxWidth={false} className="dashboard-card-container">
          <Box >
            <Grid container>
              <Grid container spacing={3} justifyContent="center">
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={item.id}>
                    <Commoncard
                      item={item}
                      nonclikable={true}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Container>


        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-tab">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="trendy-tabs-wrapper">
                  <div className="trendy-tab-container">
                    <button type="button" onClick={() => setValue("1")}
                      className={`trendy-tab ${value === "1" ? "active" : ""}`}  >SEO Metrics</button>

                    <button type="button" onClick={() => setValue("2")}
                      className={`trendy-tab ${value === "2" ? "active" : ""}`}  >Page Metrics</button>

                    <button type="button" onClick={() => setValue("3")}
                      className={`trendy-tab ${value === "3" ? "active" : ""}`}  >Internal Links</button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                {value === "1" &&
                  <DatagridComp
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    tableLoading={tableLoading}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />}
                {value === "2" &&
                  <DatagridComp
                    columns={column1}
                    rows={rows1}
                    autoheightval={autoheightval}
                    datagridval={2}
                    tableLoading={tableLoading}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />}
                {value === "3" &&
                  <DatagridComp
                    columns={column2}
                    rows={rows2}
                    autoheightval={autoheightval}
                    datagridval={2}
                    tableLoading={tableLoading}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />}
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand">Elite site Optimizer</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        {/* <div className="cnt_audit_outer_wrap">
          <div className="top_breadcrumb_menu">
            <CommonBreadCrumb breadcrumbValue={[
              { title: 'Technical' },
              { title: 'Page Health', activeColor: true, link: '/page-health/3/' },
              { title: 'View Report', activeColor: true }
            ]} />
            <div className="exportpdf_outer">
              {pagehealthPlan.status &&
                <>
                  <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                    csvdown={csvdown} pdfdown={pdfdown} />
                </>
              }
            </div>
          </div>
          <div className="cnt_hdr_top_wraps">
            <div className="cnt_hdr_top_lft_wrap">
              <h2 className="heading_font">Page Health Checker Detailed Report  </h2>
              <a target="_blank" href={queryurl} style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="spanlink" style={{ flexDirection: "column" }}>
                  {queryurl}
                </span>
              </a>
              <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>
            </div>
            <div className="cnt_hdr_top_rgt_wrap">
              <Link to={`/page-health-ignore-metrics/${plag_id}/${onpageid}`}>
                <button
                  className="runreportnew over_all_accessibility runreportnew"
                  style={{ border: "2px solid #fff" }}
                >
                  Ignored Metrics
                </button>
              </Link>

            </div>
          </div>

        </div>

        <div className="cnt_hdr_content">
          <div className="box_wrap page_health">
            <div>
              <p></p>
            </div>
            <div className="common-card-container" style={{ justifyContent: "center" }}>
              <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }}>
                <div className={`common-card-icon-container`}>
                  <div className={`common-card-icons`}>
                    <img src={plagiarismscanreport_total_wordson_pagesvg} className={`common-card-icon-img`} alt=" Total Words on Pages" />
                  </div>
                </div>
                <div className={`common-card-subtitle cardcontentactivecontainer`}>
                  <span className="common-card-title">  High Impact Issue Occurrences -- {cardData?.high_impact_issue} </span>
                  <span className="common-card-value">
                    <LiquidFillGauge
                      style={{ margin: "0 auto" }}
                      width={50}
                      height={50}
                      value={cardData?.high_impact_percentage}
                      percent="%"
                      textSize={1}
                      textOffsetX={0}
                      textOffsetY={0}
                      riseAnimation
                      waveAnimation
                      waveFrequency={2}
                      waveAmplitude={1}
                      gradient
                      gradientStops={gradientStops}
                      circleStyle={{
                        fill: "#0b2033",
                      }}
                      waveStyle={{
                        fill: "rgb(255,174,31)",
                      }}
                      textStyle={{
                        fill: color("#0b2033").toString(),
                        fontFamily: "Arial",
                      }}
                      waveTextStyle={{
                        fill: color("#0b2033").toString(),
                        fontFamily: "Arial",
                      }}
                    />
                  </span>
                </div>
              </div>
              <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }}>
                <div className={`common-card-icon-container`}>
                  <div className={`common-card-icons`}>
                    <img src={plagiarism_totalmatching_urlsvg} className={`common-card-icon-img`} alt="  Total Words" />
                  </div>
                </div>
                <div className={`common-card-subtitle cardcontentactivecontainer`}>
                  <span className="common-card-title">     Medium Impact Issue Occurrences -- {cardData?.medium_impact_issue}</span>
                  <span className="common-card-value">

                    <LiquidFillGauge
                      style={{ margin: "0 auto" }}
                      width={50}
                      height={50}
                      value={cardData?.medium_impact_percentage}
                      percent="%"
                      textSize={1}
                      textOffsetX={0}
                      textOffsetY={0}
                      riseAnimation
                      waveAnimation
                      waveFrequency={2}
                      waveAmplitude={1}
                      gradient
                      gradientStops={gradientStops}
                      circleStyle={{
                        fill: "#0b2033",
                      }}
                      waveStyle={{
                        fill: "rgb(255,174,31)",
                      }}
                      textStyle={{
                        fill: color("#0b2033").toString(),
                        fontFamily: "Arial",
                      }}
                      waveTextStyle={{
                        fill: color("#0b2033").toString(),
                        fontFamily: "Arial",
                      }}
                    />
                  </span>
                </div>
              </div>

              <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }}>
                <div className={`common-card-icon-container`}>
                  <div className={`common-card-icons`}>
                    <img src={plagiarismreport_percentage_matchingsvg} className={`common-card-icon-img`} alt="  Total Words" />
                  </div>
                </div>
                <div className={`common-card-subtitle cardcontentactivecontainer`}>
                  <span className="common-card-title"> Low Impact Issue Occurrences -- {cardData?.low_impact_issue} </span>
                  <span className="common-card-value">

                    <LiquidFillGauge
                      style={{ margin: "0 auto" }}
                      width={50}
                      height={50}
                      value={cardData?.low_impact_percentage}
                      percent="%"
                      textSize={1}
                      textOffsetX={0}
                      textOffsetY={0}
                      riseAnimation
                      waveAnimation
                      waveFrequency={2}
                      waveAmplitude={1}
                      gradient
                      gradientStops={gradientStops}
                      circleStyle={{
                        fill: "#0b2033",
                      }}
                      waveStyle={{
                        fill: "rgb(255,174,31)",
                      }}
                      textStyle={{
                        fill: color("#0b2033").toString(),
                        fontFamily: "Arial",
                      }}
                      waveTextStyle={{
                        fill: color("#0b2033").toString(),
                        fontFamily: "Arial",
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="tabs_outer_wrap tabs_outer_wrap_tab_btm_rem">
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="SEO Metrics" value="1" />
                <Tab label="Page Metrics" value="2" />
                <Tab label="Internal Links" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <DatagridComp
                columns={columns}
                rows={rows}
                autoheightval={autoheightval}
                datagridval={2}
                tableLoading={tableLoading}
              />
            </TabPanel>
            <TabPanel value="2">
              <DatagridComp
                columns={column1}
                rows={rows1}
                autoheightval={autoheightval}
                datagridval={2}
                tableLoading={tableLoading}
              />
            </TabPanel>
            <TabPanel value="3">
              <DatagridComp
                columns={column2}
                rows={rows2}
                autoheightval={autoheightval}
                datagridval={2}
                tableLoading={tableLoading}
              />
            </TabPanel>
          </TabContext>
        </div> */}

        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
        <UserActivityTracker pagename="Technical - Site Analysis - Page Health Detail" />
      </div>
    </div>
  );
}
